module.exports = __webpack_public_path__ + "static/media/work-with-us_health.16bf1516.jpg";